import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from './translations';

Vue.use(VueI18n);

// i18n

// Function to get language from the various browsers
const getNavigatorLanguage = () =>
    navigator.languages && navigator.languages.length
        ? navigator.languages[0]
        : navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en';

export const i18n = new VueI18n({
    locale: getNavigatorLanguage().split('-')[0], // set locale
    fallbackLocale: 'en', // Fallback if message is not defined for a local
    messages, // set locale messages
});
